import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full max-w-[1624px] mx-auto min-w-[768px] gap-6 pb-6 overflow-auto flex flex-row" }
const _hoisted_2 = { class: "flex items-start gap-6 w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-external-link-alt" }, null, -1)

import { computed, onMounted } from 'vue';
import { IncrediButton } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { useMatomo } from '@/services/matomo/matomo.service';
import WorkloadViewPerformanceMetricsBlock from './workload-view-performance-metrics-block.vue';
import WorkloadViewPerformanceTasks from './workload-view-performance-tasks.vue';
import WorkloadViewPerformanceBuildCache from './workload-view-performance-build-cache.vue';
import WorkloadViewPerformanceHelpersDistribution from './workload-view-performance-build-helpers-distribution.vue';
import { useWorkloadViewPerformanceDataProvider } from './workload-view-performance.helpers';

type Props = {
  id: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-performance-metrics',
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
}



const { performance } = useWorkloadViewPerformanceDataProvider(props.id);

const matomo = useMatomo();

onMounted(() => {
  matomo?.trackEvent({
    category: 'Build page',
    action: 'Click',
    name: 'Build performance metrics tab',
  });
});

const isBuildCache = computed(() => performance.value?.isBuildCache === true);

const buildCache = computed(() => ({
  chaceable: performance.value?.cacheableTasks,
  chaceablePercentage: performance.value?.cacheableTasksPercentage,
  uncacheable: performance.value?.uncacheableTasks,
  uncacheablePercentage: performance.value?.uncacheableTasksPercentage,
  hits: performance.value?.cacheTaskHits,
  hitsPercentage: performance.value?.cacheTaskHitsPercentage,
  misses: performance.value?.cacheTaskMiss,
  missesPercentage: performance.value?.cacheTaskMissPercentage,
}));

const tasksDetails = computed(() => ({
  tasks: {
    cache: { success: performance.value?.cacheTaskHits || 0 },
    remote: performance.value?.tasksDistribution?.remoteTasks || {},
    local: performance.value?.tasksDistribution?.localTasks || {},
  },
  totalTasks: performance.value?.totalTasks,
  localTasks: performance.value?.localTasks,
  remoteTasks: performance.value?.remoteTasks,
  cacheableTasksPercentage: performance.value?.cacheableTasksPercentage,
  uncacheableTasksPercentage: performance.value?.uncacheableTasksPercentage,
  cacheTaskHits: performance.value?.cacheTaskHits,
  cacheTaskHitsPercentage: performance.value?.cacheTaskHitsPercentage,
  remoteTasksPercentage: performance.value?.remoteTasksPercentage,
  localTasksPercentage: performance.value?.localTasksPercentage,
  distributableTasks: performance.value?.distributableTasks,
  nonDistributableTasks: performance.value?.nonDistributableTasks,
  longestTasks: (performance.value?.longestTasks || []).map(task => ({
    taskId: task?.id || 0,
    taskName: task?.name || '',
    taskMachineName: task?.machineName || '',
    duration: task?.duration || 0,
    durationPercentage: task?.durationPercentage || 0,
  })),
}));

const helpers = computed(() => ({
  cpuTime: {
    total: performance.value?.totalCpuTime,
    distributed: performance.value?.distributedCpuTime,
    distributedPercentage: performance.value?.distributedCpuTimePercentage,
  },
  shortfallPercentage: performance.value?.readyOverActiveRatio,
  agents: {
    max: performance.value?.maxHelperMachines,
    avg: performance.value?.avgHelperMachines,
  },
  cores: {
    max: performance.value?.maxHelperCores,
    avg: performance.value?.avgHelperCores,
  },
}));

const readMoreClick = () => {
  window.open(process.env.VUE_APP_DOCUMENTATION_BUILD_CACHE_MONITOR_WINDOWS, '_blank');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-performance-metrics mx-auto w-full max-h-full px-6" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(WorkloadViewPerformanceMetricsBlock, {
            class: "grow",
            title: _ctx.$t('workloads.details.performanceMetricsTab.tasks.title')
          }, {
            default: _withCtx(() => [
              _createVNode(WorkloadViewPerformanceTasks, _mergeProps(_unref(tasksDetails), { "is-build-cache": _unref(isBuildCache) }), null, 16, ["is-build-cache"])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        (_unref(isBuildCache))
          ? (_openBlock(), _createBlock(WorkloadViewPerformanceMetricsBlock, {
              key: 0,
              title: _ctx.$t('workloads.details.performanceMetricsTab.buildCache.title'),
              class: "w-full",
              "data-testid": "build-cache-block"
            }, {
              "extra-header": _withCtx(() => [
                _createVNode(_unref(IncrediButton), {
                  "data-testid": "read-more-button",
                  design: "ghost-grey",
                  size: "tiny",
                  class: "flex gap-1.5 bg-Hovers/hover_grey",
                  onClick: readMoreClick
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.buildCache.readMore')), 1),
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(WorkloadViewPerformanceBuildCache, _normalizeProps(_guardReactiveProps(_unref(buildCache))), null, 16)
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        _createVNode(WorkloadViewPerformanceMetricsBlock, {
          title: _ctx.$t('workloads.details.performanceMetricsTab.helperDistribution.title'),
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(WorkloadViewPerformanceHelpersDistribution, _normalizeProps(_guardReactiveProps(_unref(helpers))), null, 16)
          ]),
          _: 1
        }, 8, ["title"])
      ])
    ]),
    _: 1
  }))
}
}

})